import { FilterQuery } from '@yes.technology/react-toolkit'

function getFilteredStartDate(filterquery: FilterQuery | undefined) {
  if (!filterquery) {
    return { filteredStartDate: null, operator: null }
  }

  const [appliedFilter] = Object.values(
    filterquery?.$and?.find((query) => !!query['start_date.des']) || {}
  )

  const filteredStartDate = Object.values(appliedFilter ?? {})?.[0] as string

  const operator = Object.keys(appliedFilter ?? {})?.[0] as string

  return { filteredStartDate, operator }
}

export default getFilteredStartDate
